module.exports = __webpack_public_path__ + "img/dialog-pic@3x.62883bb6.png";